const DepartmentActionTypes = {
  /** ***************** ADD DEPARTMENT DETAILS START *********************** */
  ADD_DEPARTMENT_DETAILS_START: "add_department_details_start",
  ADD_DEPARTMENT_DETAILS_SUCCESS: "add_department_details_success",
  ADD_DEPARTMENT_DETAILS_FAILURE: "add_department_details_failure",
  ADD_DEPARTMENT_DETAILS_RESPONSE_RESET:
    "add_department_details_response_reset",
  ADD_DEPARTMENT_DETAILS_RESPONSE_CHANGED:
    "add_department_details_response_changed",
  /** ***************** ADD DEPARTMENT DETAILS END *********************** */

  /** ***************** UPDATE DEPARTMENT DETAILS START *********************** */
  UPDATE_DEPARTMENT_DETAILS_START: "update_department_details_start",
  UPDATE_DEPARTMENT_DETAILS_SUCCESS: "update_department_details_success",
  UPDATE_DEPARTMENT_DETAILS_FAILURE: "update_department_details_failure",
  UPDATE_DEPARTMENT_DETAILS_RESPONSE_RESET:
    "update_department_details_response_reset",
  UPDATE_DEPARTMENT_DETAILS_RESPONSE_CHANGED:
    "update_department_details_response_changed",
  /** ***************** UPDATE DEPARTMENT DETAILS END *********************** */

  /** ***************** GET DEPARTMENT DETAILS START *********************** */
  GET_DEPARTMENT_LIST_START: "get_department_list_start",
  GET_DEPARTMENT_LIST_SUCCESS: "get_department_list_success",
  GET_DEPARTMENT_LIST_FAILURE: "get_department_list_failure",
  GET_DEPARTMENT_LIST_RESPONSE_RESET: "get_department_list_response_reset",
  GET_DEPARTMENT_LIST_RESPONSE_CHANGED: "get_department_list_response_changed",
  /** ***************** GET DEPARTMENT DETAILS END *********************** */

  /** ***************** FETCH DEPARTMENT DETAILS START *********************** */
  FETCH_DEPARTMENT_DETAILS_START: "fetch_department_details_start",
  FETCH_DEPARTMENT_DETAILS_SUCCESS: "fetch_department_details_success",
  FETCH_DEPARTMENT_DETAILS_FAILURE: "fetch_department_details_failure",
  FETCH_DEPARTMENT_DETAILS_RESPONSE_RESET:
    "fetch_department_details_response_reset",
  FETCH_DEPARTMENT_DETAILS_RESPONSE_CHANGED:
    "fetch_department_details_response_changed",
  /** ***************** FETCH DEPARTMENT DETAILS START *********************** */

  /** ***************** DELETE DEPARTMENT DETAILS START *********************** */
  DELETE_DEPARTMENT_DETAILS_START: "delete_department_details_start",
  DELETE_DEPARTMENT_DETAILS_SUCCESS: "delete_department_details_success",
  DELETE_DEPARTMENT_DETAILS_FAILURE: "delete_department_details_failure",
  DELETE_DEPARTMENT_DETAILS_RESPONSE_RESET:
    "delete_department_details_response_reset",
  DELETE_DEPARTMENT_DETAILS_RESPONSE_CHANGED:
    "delete_department_details_response_changed",
  /** ***************** DELETE DEPARTMENT DETAILS END *********************** */
};
export default DepartmentActionTypes;
